module.exports = __webpack_public_path__ + "static/media/golfer-2-b.7c665e37.png";